import i18n from 'client/i18n'
import { createContainerStructure } from 'client/utils/createStructureUtils'
import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'
import { createField } from 'src/shared/entities/field/create-field'
import { createPopup } from 'src/shared/entities/popup/create-popup'
import { createText } from 'src/shared/entities/text/create-text'

export const createPopupFromLibrary = (locale: string) => {
  const fixedT = i18n.getFixedT(locale)

  const popupEntity = createPopup()

  const { structure, descendantEntity } = createContainerStructure(
    popupEntity,
    locale,
    0,
  )

  const headerText = createText(
    descendantEntity.id,
    undefined,
    fixedT('entities.text.subscribe_text'),
  )
  headerText.fontSize = 35
  headerText.textAlign = 'center'
  headerText.fontFamily = 'Raleway'
  headerText.lineHeight = 45

  const input = createField(
    descendantEntity.id,
    descendantEntity.masterBlockId,
    {
      slug: FieldSlugEnum.Email,
      placeholder: 'Email',
    },
  )

  const button = createButtonNew(
    descendantEntity.id,
    fixedT('entities.button.default_text'),
    fixedT('entities.button.default_sub_text'),
    descendantEntity.masterBlockId,
  ) as SendFormActionButtonEntityInterface
  button.background = 'rgba(74, 144, 226, 1)'
  button.border = {
    ...button.border,
    radius: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
  }
  button.textColor = 'rgba(255, 255, 255, 1)'
  button.textFontFamily = 'Raleway'
  button.textFontSize = 24
  button.lineHeight = 24
  button.margin = {
    marginTop: 15,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  }
  button.width = '100%'
  button.redirectionType = RedirectionTypesEnum.customUrl
  button.padding = {
    paddingTop: 6,
    paddingRight: 100,
    paddingBottom: 7,
    paddingLeft: 100,
  }

  const caption = createText(
    descendantEntity.id,
    undefined,
    fixedT('entities.text.hate_spam'),
  )
  caption.backgroundColor = 'rgba(155, 155, 155, 0)'
  caption.fontSize = 15
  caption.margin = {
    marginTop: 10,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 0,
  }
  caption.textAlign = 'center'

  return {
    ascendantId: popupEntity.id,
    structure: {
      ...structure,
      [descendantEntity.id]: {
        ...descendantEntity,
        childIds: [headerText.id, input.id, button.id, caption.id],
      },
      [popupEntity.id]: {
        ...popupEntity,
        childIds: [structure[descendantEntity.parentId as string].id],
      },
      [headerText.id]: headerText,
      [input.id]: input,
      [button.id]: button,
      [caption.id]: caption,
    },
  }
}
